import {
  FETCH_MARKET_PRODUCTS_REQUEST,
  FETCH_MARKET_PRODUCTS_SUCCESS,
  FETCH_MARKET_PRODUCTS_FAILURE,
  CLEAR_MARKET_PRODUCTS,
} from '../actions/marketProductsActions';

const initialState = { byCategoryId: {} };

const marketProductsReducer = ( state = initialState, action ) => {
  switch ( action.type ) {
  case FETCH_MARKET_PRODUCTS_REQUEST:
    return {
      ...state,
      byCategoryId: {
        ...state.byCategoryId,
        [action.payload.categoryId]: {
          ...( state.byCategoryId[action.payload.categoryId] || {} ), // Validar si el objeto existe
          loading: true,
          error: null,
        },
      },
    };
  case FETCH_MARKET_PRODUCTS_SUCCESS:
    return {
      ...state,
      byCategoryId: {
        ...state.byCategoryId,
        [action.payload.categoryId]: {
          ...( state.byCategoryId[action.payload.categoryId] || {} ), // Validar si el objeto existe
          data: action.payload.data,
          loading: false,
          error: null,
        },
      },
    };
  case FETCH_MARKET_PRODUCTS_FAILURE:
    return {
      ...state,
      byCategoryId: {
        ...state.byCategoryId,
        [action.payload.categoryId]: {
          ...( state.byCategoryId[action.payload.categoryId] || {} ), // Validar si el objeto existe
          loading: false,
          error: action.payload.error,
        },
      },
    };
  case CLEAR_MARKET_PRODUCTS:
    return {
      ...state,
      byCategoryId: {},
    };
  default:
    return state;
  }
};

export default marketProductsReducer;
